import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
function sendRushRulesPopupAnalytic(type) {
    const eventData = {
        type: type,
        category: AnalyticEventCategory.MainFunnel
    };
    void CA.sendAnalyticEvent(eventData);
}
export function sendRushRulesPopupShown() {
    sendRushRulesPopupAnalytic(AnalyticEventType.RushRulesPopupShown);
}
export function sendRushRulesPopupStartGameClicked() {
    sendRushRulesPopupAnalytic(AnalyticEventType.RushRulesPopupStartGameClicked);
}
export function sendRushRulesPopupDismissed() {
    sendRushRulesPopupAnalytic(AnalyticEventType.RushRulesPopupDismissed);
}
export function sendRushRulesPopupVideoClicked() {
    sendRushRulesPopupAnalytic(AnalyticEventType.RushRulesPopupVideoClicked);
}
